// // src/firebase-config.ts
// import { initializeApp } from "firebase/app";
// import { getMessaging, isSupported } from "firebase/messaging";
// import { firebaseConfig } from "../config/firebase-config";

// export const firebaseApp = initializeApp(firebaseConfig);

// const messaging = async () =>{
//     let res = await isSupported() ? getMessaging(firebaseApp) : null;
//     return res;
// }

// export { messaging };

import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { firebaseConfig } from "../config/firebase-config";

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// ✅ Keep same export name & structure, but fix async logic
const messaging = async () => {
  try {
    const supported = await isSupported();

    if (!supported) {
      console.warn("🚫 This browser does not support Firebase messaging.");
      return null;
    }

    // Register service worker before using messaging
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    console.log("✅ Service worker registered:", registration);

    // Initialize and return messaging instance
    const msg = getMessaging(firebaseApp);
    return msg;
  } catch (error) {
    console.error("Error initializing Firebase messaging:", error);
    return null;
  }
};

export { messaging };
